export default __webpack_public_path__ + "static/1693-97ee314ec357369fc7b1ec35708f450a.gif";